@if (
  {
    resourcesColumnWidthPx: resourcesColumnWidthPx$ | async,
    demarcatorRange: demarcatorRange$ | async,
    isAssignmentMode: dragAndDropModeService.isAssignmentMode$ | async,
    horizontalDemarcatorRange:
      (dragAndDropModeService.horizontalDemarcatorRange$ | async),
    isDrawerVisible: isDrawerVisible$ | async,
    shouldDisplayMovingDemarcatorLine:
      dragAndDropModeService.shouldDisplayMovingDemarcatorLine$ | async,
  };
  as data
) {
  <div
    class="line-wrappers"
    [style.margin-left.px]="data.resourcesColumnWidthPx"
    [style.width.px]="frameLength$ | async"
  >
    @if (data?.demarcatorRange?.left || data.horizontalDemarcatorRange?.left) {
      <div
        class="drop-zone-start"
        [style.left.px]="
          data.isDrawerVisible || !data.shouldDisplayMovingDemarcatorLine
            ? (data.demarcatorRange?.left ?? 0)
            : (data.horizontalDemarcatorRange?.left ?? 0)
        "
      ></div>
    }
    @if (data?.demarcatorRange?.right || data.horizontalDemarcatorRange?.left) {
      <div
        class="drop-zone-end"
        [style.right.px]="
          data.isDrawerVisible || !data.shouldDisplayMovingDemarcatorLine
            ? data.demarcatorRange?.right
            : data.horizontalDemarcatorRange?.right
        "
      ></div>
    }
  </div>
}
